import { Dispatch } from 'redux';
import { RestApi } from '../../services/restapi.service';
import {  ActionRequestState, ActionRequestStateWithData, ActionType, CreateUserRequestBody, HttpState, UpdateUserRequestBody, UserData } from '../../util/model';

export const actionGetUsers = (deleteUsersBefore = true) => async (dispatch: Dispatch) => {
    try {
        if(deleteUsersBefore) {
            const progress: ActionRequestStateWithData<UserData[]> = {
                type: ActionType.REQUEST_USER_LIST,
                state: HttpState.Progress,
                payload: []
            }
            dispatch(progress as any)
        }
        const users = await RestApi.getUsers();
        const success: ActionRequestStateWithData<UserData[]> = {
            type: ActionType.REQUEST_USER_LIST,
            state: HttpState.Success,
            payload: users.data
        }
        dispatch(success as any)
    } catch (error) {
        console.log('error', error);
        const failure: ActionRequestStateWithData<UserData[]> = {
            type: ActionType.REQUEST_USER_LIST,
            state: HttpState.Failure,
            payload: []
        }
        dispatch(failure as any)
        
    }
}

export const actionCreateUser = (body: CreateUserRequestBody) => async (dispatch: Dispatch) => {
    try {
        const progress: ActionRequestState = {
            type: ActionType.REQUEST_CREATE_USER,
            payload: HttpState.Progress
        }
        dispatch(progress as any)
        await RestApi.createUser(body);
        const success: ActionRequestState = {
            type: ActionType.REQUEST_CREATE_USER,
            payload: HttpState.Success
        }
        dispatch(success as any)
    } catch (error) {
        const failure: ActionRequestState = {
            type: ActionType.REQUEST_CREATE_USER,
            payload: HttpState.Failure
        }
        dispatch(failure as any)
    }
}


export const actionUpdateUser = (id: string, body: UpdateUserRequestBody) => async (dispatch: Dispatch) => {
    try {
        const progress: ActionRequestState = {
            type: ActionType.REQUEST_UPDATE_USER,
            payload: HttpState.Progress
        }
        dispatch(progress as any)
        await RestApi.updateUser(id, body);
        const success: ActionRequestState = {
            type: ActionType.REQUEST_UPDATE_USER,
            payload: HttpState.Success
        }
        dispatch(success as any)
    } catch (error) {
        const failure: ActionRequestState = {
            type: ActionType.REQUEST_UPDATE_USER,
            payload: HttpState.Failure
        }
        dispatch(failure as any)
    }
}

export const actionUpdatePassword = (id: string, password: string) => async (dispatch: Dispatch) => {
    try {
        const progress: ActionRequestState = {
            type: ActionType.REQUEST_UPDATE_USER_PASSWORD,
            payload: HttpState.Progress
        }
        dispatch(progress as any)
        await RestApi.updateUserPassword(id, {password});
        const success: ActionRequestState = {
            type: ActionType.REQUEST_UPDATE_USER_PASSWORD,
            payload: HttpState.Success
        }
        dispatch(success as any)
    } catch (error) {
        const failure: ActionRequestState = {
            type: ActionType.REQUEST_UPDATE_USER_PASSWORD,
            payload: HttpState.Failure
        }
        dispatch(failure as any)
    }
}

export const actionDeleteUser = (id: string) => async (dispatch: Dispatch) => {
    try {
        const progress: ActionRequestState = {
            type: ActionType.REQUEST_DELETE_USER,
            payload: HttpState.Progress,
        }
        dispatch(progress as any)
        await RestApi.deleteUser(id);
        const success: ActionRequestState = {
            type: ActionType.REQUEST_DELETE_USER,
            payload: HttpState.Success
        }
        dispatch(success as any)
    } catch (error) {
        const failure: ActionRequestState = {
            type: ActionType.REQUEST_DELETE_USER,
            payload: HttpState.Failure
        }
        dispatch(failure as any)
    }
}

export const actionClearEditUserCache = () => ({
    type: ActionType.CLEAR_USER_EDIT_CACHE
})

